// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import RouteWrapper from './RouteWrapper';
import Optionchain from './component/front/Optionchain';
import Home from './component/front/Home';
import About from './component/front/About';
import BackTester from './component/front/BackTester';
import PrivacyPolicy from './component/front/PrivacyPolicy';
import Contact from './component/front/Contact';
import Pricing from './component/front/Pricing';
import CancelPolicy from './component/front/CancelPolicy';
import DailyAnalysis from './component/front/DailyAnalysis';
import DailyAnalysisChart from './component/front/DailyAnalysisChart';
import SrStock from './component/front/SrStock';
import Snapshot from './component/front/Snapshot';
import StraddelChart from './component/front/StraddleChart';
import TripleSrStock from './component/front/TripleSrStock';
import PowerStocks from './component/front/PowerStocks';
import SellingStockIndex from './component/front/SellingStockIndex';
import TrendWithStocks from './component/front/TrendWithStocks';
import HotStock from './component/front/HotStock';
import HotOption from './component/front/hotOptionStock';
import TermAndServices from './component/front/TermAndServices';
import Blog from './component/front/Blog';
import AdminLayout from './component/admin/AdminLayout';
import AdminLogin from './component/admin/AdminLogin';
import AdminDashboard from './component/admin/AdminDashboard';
import UserManagement from './component/admin/UserManagement';
import Plan from './component/admin/Plan';
import Day from './component/admin/Day';
import Percentage from './component/admin/Percentage';
import AddPlan from './component/admin/AddComponent/AddPlan';
import AddSubscription from './component/admin/AddComponent/AddSubscription';
import Profile from './component/front/Profile';
import Subscription from './component/admin/Subscription';
import AdminPrivacyPolicy from './component/admin/Policies/PrivacyPolicy';
import AdminCanclePolicy from './component/admin/Policies/CancleAndRefund';
import AdminTermAndCondition from './component/admin/Policies/TermAndCondition';
import Notification from './component/admin/Notification';
import AddNotification from './component/admin/AddComponent/AddNotification';
import Video from './component/admin/Video';
import AddVideo from './component/admin/AddComponent/AddVideo';
import AboutUs from './component/admin/AboutUs';
import Vega from './component/front/VegaTable';
import TradingVideo from './component/front/TradingVideo';
import Profileadmin from './component/admin/Profile';
import ContactUs from './component/admin/ContactUs';
import LandingPage from './component/admin/LandingPage';
import BlogList from './component/admin/BlogList';
import AddBlog from './component/admin/AddComponent/AddBlog';
import { AuthProvider } from './AuthContext'; // Import UserProvider
import { AdminProvider, AdminContext } from './AdminContext'; // Import AdminProvider
import { ThemeProvider } from './context/ThemeContext';
import TrandingStock from './component/admin/TrandingStock';
import AddStock from './component/admin/AddComponent/AddStock';
import TraindingStock from './component/front/TraindigStock';
import StockDec from './component/front/StockDec';
import SingleBlogPage from './component/front/SingleBlog';
import MomentIndicator from './component/front/MomentIndicator';
import Scanner from './component/front/ScannerVIewTrading';
import PrivateRoute from './PrivateRoute';
import AddHotChart from './component/admin/AddComponent/AddHotChart';
import HotChart from './component/admin/HotChart';
import UserHotChart from './component/front/UserHotChart';
import Webhook from './component/admin/Webhook';
import AddWeabhook from './component/admin/AddComponent/AddWebhook';

function App() {
  const [searchValue, setSearchValue] = React.useState('');
  const [trading, setTrading] = React.useState('');
  const [tradingTwo, setTradingTwo] = React.useState('');
  const handleSearchChange = (value) => {
    localStorage.setItem('searchValue', value.name);
    setSearchValue(value);
  };

  const handleTrading = (value) => {
    setTrading(value);
  }
  const handleTradingTwo = (value) => {
    setTradingTwo(value);
  }

  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <AdminProvider>
            <RouteWrapper onSearchChange={handleSearchChange} trading={trading} tradingTwo={tradingTwo} >
              <Routes>
              {/* Frontend Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/backtester" element={<BackTester />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/term-and-services" element={<TermAndServices />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/trading-video" element={<PrivateRoute><TradingVideo /></PrivateRoute>} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/dailyanalysis" element={<DailyAnalysis />} />
              <Route path="/daily-analysis-chart" element={<DailyAnalysisChart />} />
              <Route path="/cancelpolicy" element={<CancelPolicy />} />
              <Route path="/optionchain" element={<Optionchain searchValue={searchValue} onTradingChange={handleTrading} onTradingChangetwo={handleTradingTwo} />} />
              <Route path="/optionSnapshot" element={<Snapshot searchValue={searchValue} onTradingChange={handleTrading} onTradingChangetwo={handleTradingTwo} />} />
              <Route path="/vegaTable" element={<Vega searchValue={searchValue} onTradingChange={handleTrading} onTradingChangetwo={handleTradingTwo} />} />

              <Route path="/straddleChart" element={<StraddelChart />} />
              <Route path="/scanner" element={<Scanner />} />
              <Route path="/sr-stock" element={<SrStock />} />
              <Route path="/strong-sr-stock" element={<TripleSrStock />} />
              <Route path="/power-stocks" element={<PowerStocks />} />
              <Route path="/selling-stock-index" element={<SellingStockIndex />} />
              <Route path="/trend-with-stocks" element={<TrendWithStocks />} />
              <Route path="/hot-stock" element={<HotStock />} />
              <Route path="/hot-option" element={<HotOption />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<SingleBlogPage />} />
              <Route path="/tainding-stock" element={<TraindingStock />} />
              <Route path="/tainding-stock/:id" element={<StockDec />} />
              <Route path="/moment-indicator" element={<MomentIndicator />} />
              <Route path="/hot-chart" element={<UserHotChart />} />
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route element={<ProtectedAdminRoute />}>
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="usermanager" element={<UserManagement />} />
                  <Route path="day" element={<Day />} />
                  <Route path="percentage" element={<Percentage />} />
                  <Route path="plan" element={<Plan />} />
                  <Route path="add-plan" element={<AddPlan />} />
                  <Route path="subscription" element={<Subscription />} />
                  <Route path="add-subscription" element={<AddSubscription />} />
                  <Route path="privacy-policy" element={<AdminPrivacyPolicy />} />
                  <Route path="cancle-policy" element={<AdminCanclePolicy />} />
                  <Route path="term-and-condition" element={<AdminTermAndCondition />} />
                  <Route path="notification" element={<Notification />} />
                  <Route path="add-notification" element={<AddNotification />} />
                  <Route path="hotchart" element={<HotChart />} />
                  <Route path="add-hotchart" element={<AddHotChart />} />
                  <Route path="about" element={<AboutUs />} />
                  <Route path="video" element={<Video />} />
                  <Route path="add-video" element={<AddVideo />} />
                  <Route path="profile" element={<Profileadmin />} />
                  <Route path="contact" element={<ContactUs />} />
                  <Route path="landingPage" element={<LandingPage />} />
                  <Route path="blog-list" element={<BlogList />} />
                  <Route path="blog" element={<AddBlog />} />
                  <Route path="stock" element={<TrandingStock />} />
                  <Route path="add-stock" element={<AddStock />} />
                  <Route path="webhook" element={<Webhook />} />
                  <Route path="add-webhook" element={<AddWeabhook />} />
                </Route>
              </Route>
            </Routes>
            </RouteWrapper>
          </AdminProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

// ProtectedAdminRoute for protecting admin routes
const ProtectedAdminRoute = () => {
  const { admin, adminToken } = React.useContext(AdminContext);

  if (!admin || !adminToken) {
    // Redirect to the admin login page if not authenticated
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />; // Renders the nested routes if authenticated
};

export default App;
